import apiClient from "../apiClient";
import { MenuItem } from "./menu";

const baseUrl = '/system/users'

export type UserItem = {
    _id: string;
    userId: string;
    username: string;
    name: string;
    phone?: string;
    email?: string;
    role: string;
    status: 'enabled' | 'disabled';
    remark?: string;
    createdAt?: string;
};

/** 分页列表 */
export async function queryUserList(params: {
    current?: number;
    pageSize?: number;
    username?: string;
    roleCode?: string;
}) {
    return apiClient<{
        list: UserItem[];
        total: number;
    }>(baseUrl, {
        method: 'GET',
        params,
    });
}

/** 新增用户 */
export async function addUser(data: UserItem) {
    return apiClient<{ code: number }>(baseUrl, {
        method: 'POST',
        data,
    });
}

/** 更新用户 */
export async function updateUser(id: string, data: UserItem) {
    return apiClient<{ code: number }>(`${baseUrl}/${id}`, {
        method: 'PUT',
        data,
    });
}

/** 删除用户 */
export async function deleteUser(id: string) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'DELETE',
    });
}


const baseUrlRole = `${baseUrl}/role`
/** 分页列表 除role以外的用户 */
export async function getExcludeRoleUsers(params: {
    current?: number;
    pageSize?: number;
    roleCode?: string;
}) {
    return apiClient<{
        list: UserItem[]; total: number;
    }>(baseUrlRole, {
        method: 'GET',
        params,
    });
}

// 绑定用户
export async function addRoleUser(data: { roleCode: string; userIds: string[] }) {
    return apiClient(baseUrlRole, {
        method: 'POST',
        data,
    });
}

/** 解除绑定 */
export async function deleteRoleUser(userId: string) {
    return apiClient(baseUrlRole, {
        data: { userId },
        method: 'DELETE',
    });
}


// 查找该用户下的菜单数据
export async function getUserMenus(userId: string) {
    return apiClient<{
        list: MenuItem[];
        total: number;
        allMenus?: string[]
    }>('/system/users/menus', {
        params: { userId },
    });
}